<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="plus" class="add-btn" @click="addCard">
          新增评分卡
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <!-- 被引用次数 -->
        <template v-slot:targetUsed="{ tableRow }">
          <a-popover trigger="click" placement="bottom">
            <span @click="dataOpen(tableRow)">
              {{ tableRow.targetUsed }}
            </span>
            <a slot="content">
              <a-table
                :columns="usedColumns"
                :dataSource="usedData"
                :pagination="false"
                :scroll="{ x: 800 }"
                :rowKey="
                  (record, index) => {
                    return index
                  }
                "
              >
                <template>
                  <a-button
                    type="link"
                    size="small"
                    @click="handleDetail(tableRow)"
                  >
                    详情
                  </a-button>
                  <a-divider type="vertical" />
                </template>
              </a-table>
            </a>
          </a-popover>
        </template>
        <template v-slot:freeze="{ tableRow }">
          <span>
            <a-tag :color="tableRow.freeze === 0 ? 'green' : 'volcano'">
              {{ tableRow.freeze === 0 ? '激活' : '冻结' }}
            </a-tag>
          </span>
        </template>
        <template v-slot:action="{ tableRow }">
          <div>
            <template
              v-if="tableRow.freeze === 0 && Number(tableRow.targetUsed) === 0"
            >
              <a-button type="link" size="small" @click="handleEdit(tableRow)">
                编辑
              </a-button>
              <a-divider type="vertical" />
            </template>

            <template>
              <a-button
                type="link"
                size="small"
                @click="handleDetail(tableRow)"
              >
                详情
              </a-button>
              <a-divider type="vertical" />
            </template>

            <!-- <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将删除该项信息, 是否继续?"
                @confirm="handleDeleteConfirm(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">删除</a-button>
              </a-popconfirm>
              <a-divider type="vertical" />
            </template> -->

            <template v-if="tableRow.freeze === 0">
              <a-popconfirm
                title="此操作将冻结该评分卡, 是否继续?"
                @confirm="handleFreeze(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">冻结</a-button>
              </a-popconfirm>
            </template>

            <template v-if="tableRow.freeze === 1">
              <a-popconfirm
                title="此操作将解冻该评分卡, 是否继续?"
                @confirm="handleThaw(tableRow)"
              >
                <a-icon
                  slot="icon"
                  type="question-circle-o"
                  class="icon-color"
                />
                <a-button type="link" size="small">解冻</a-button>
              </a-popconfirm>
            </template>
          </div>
        </template>
      </TableView>
    </a-card>

    <!-- 新增修改评分卡 -->
    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
      :width="1200"
      :ok-button-props="{ style: { display: checkDetail ? 'none' : 'inline' } }"
    >
      <a-card>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <a-form :form="formCard" style="display: flex; width: 30%">
            <a-form-item label="名称">
              <a-input
                :maxLength="100"
                allowClear
                v-decorator="$decorator('cardName', '请填写评分卡名称')"
                style="width: 200px"
                :disabled="checkDetail"
              ></a-input>
            </a-form-item>
          </a-form>
          <div style="display: flex; align-items: center; width: 70%">
            <a-tooltip placement="topLeft">
              <template #title>选择指标</template>
              <a-button
                type="primary"
                icon="plus"
                class="add-btn"
                @click="getTargetTableList"
                style="background: #ffffff; color: #468bfe; font-weight: 600"
                :disabled="checkDetail"
              >
                指标总数：{{
                  Number(financeTargetNum) + Number(noFinancetargetNum)
                }}
              </a-button>
            </a-tooltip>
            <div class="card_title">
              <!-- <div class="card_title_div">指标总数：{{ Number(financeTargetNum) + Number(noFinancetargetNum) }}</div> -->
              <div class="card_title_div">财务指标：{{ financeTargetNum }}</div>
              <div class="card_title_div">
                非财务指标：{{ noFinancetargetNum }}
              </div>
              <div class="card_title_div" style="width: 150px">
                未分配权重:
                <span style="color: red; font-size: 18px; font-weight: 600">
                  {{ weightAll }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </a-card>
      <!--已选择指标列表-->
      <a-card style="margin-top: 10px" class="cardTarget">
        <a-row
          class="card_target"
          type="flex"
          justify="space-between"
          :gutter="20"
          style="margin-left: 0px"
        >
          <transition-group
            tag="div"
            class="container"
            v-if="targetList.length > 0"
          >
            <a-col
              :span="12"
              v-for="(item, i) in targetList"
              :key="item.id"
              draggable="true"
              @dragstart="handleDragStart($event, item)"
              @dragover.prevent="handleDragOver($event, item)"
              @dragenter="handleDragEnter($event, item)"
              @dragend="handleDragEnd($event, item)"
              style="margin-bottom: 15px"
            >
              <div
                class="card_target_div"
                :class="[
                  item.customTargetRangeList.length == 0
                    ? 'target_color_yellow'
                    : 'target_color_bule',
                ]"
              >
                <div class="target_index">
                  <div style="margin-top: -10px">{{ i + 1 }}</div>
                  <div
                    style="margin-top: 10px; width: 15px; height: 15px"
                    @click="deleteTargetList(item)"
                    v-if="!checkDetail"
                  >
                    <a-tooltip placement="topLeft">
                      <template #title>删除指标</template>
                      <img
                        src="./images/delete_white.png"
                        style="width: 100%; height: 100%"
                      />
                    </a-tooltip>
                  </div>
                </div>
                <div class="target_insert">
                  <div class="card_target_div_left">
                    <div class="card_target_div_left_title">
                      <a-tooltip placement="topLeft">
                        <template #title>{{ item.targetName }}</template>
                        {{ item.targetName }}
                      </a-tooltip>
                    </div>
                    <div class="card_target_div_left_bottom">
                      <div style="width: 100px; height: 20px">
                        <div
                          :class="
                            item.targetType == '0'
                              ? 'target_type_style'
                              : 'target_type_style_fei'
                          "
                        >
                          <span v-if="item.targetType == '0'">非财务指标</span>
                          <span v-else>财务指标</span>
                        </div>
                      </div>
                      <div>
                        权重:
                        <a-input-number
                          id="inputNumber"
                          v-model="item.targetWeight"
                          :min="0"
                          :max="100"
                          style="margin-left: 10px; width: 100px"
                          @change="changeWeight()"
                          :disabled="checkDetail"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="card_target_div_right">
                    <div style="cursor: pointer">
                      <div v-if="item.dataType == '1'">
                        <div
                          v-for="(scoreList, i) in item.customTargetRangeList"
                          :key="i"
                        >
                          <div>
                            <span
                              v-if="
                                (scoreList.minScore &&
                                  scoreList.minScore != '') ||
                                  (scoreList.minScore == 0 && i != 0)
                              "
                            >
                              {{ scoreList.minScore }} &lt;=
                            </span>
                            值
                            <span
                              v-if="
                                (scoreList.maxScore &&
                                  scoreList.maxScore != '') ||
                                  scoreList.maxScore == 0
                              "
                            >
                              &lt; {{ scoreList.maxScore }}
                            </span>
                            : {{ scoreList.targetScore }}分
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                          v-for="(scoreList, i) in item.customTargetRangeList"
                          :key="i"
                        >
                          <div>
                            {{ scoreList.targetName }}:{{
                              scoreList.targetScore
                            }}分
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="target_index"
                  @click="goToSetting(item, i)"
                  style="font-size: 13px; cursor: pointer"
                  v-if="!checkDetail"
                >
                  <a-tooltip placement="topLeft">
                    <template #title>设置指标分值区间</template>
                    设置
                  </a-tooltip>
                </div>
                <div
                  class="target_index"
                  style="width: 10px"
                  v-if="checkDetail"
                ></div>
              </div>
            </a-col>
          </transition-group>
          <div v-else style="width: 100%; text-align: center">
            暂无数据~~~,请点击上方按钮选择指标！！
          </div>
        </a-row>
      </a-card>
    </a-modal>

    <!-- 选择指标 -->
    <a-modal
      v-model="chooseTarget"
      destroyOnClose
      @ok="handleSubmitTarget"
      title="选择指标"
      :maskClosable="false"
      :afterClose="handleAfterChooseClose"
      :width="1400"
    >
      <a-row :gutter="4">
        <a-col class="gutter-row" :span="6">
          <div class="target_tree">
            <a-tree
              ref="propertyTree"
              checkable
              :selectable="false"
              :tree-data="propertyTrees"
              checkStrictly
              :default-expanded-keys="expandedKey"
              @check="checkPropertyTree"
              v-model="selectedPropertyKeys"
              :replaceFields="{
                key: 'id',
                title: 'targetName',
                children: 'children',
              }"
            ></a-tree>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <div class="target_tree">
            <a-tree
              checkable
              :selectable="false"
              :tree-data="lossTrees"
              checkStrictly
              :default-expanded-keys="expandedKey"
              @check="checkLossTree"
              v-model="selectedPropertyKeys"
              :replaceFields="{
                key: 'id',
                title: 'targetName',
                children: 'children',
              }"
            ></a-tree>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <div class="target_tree">
            <a-tree
              checkable
              :selectable="false"
              :tree-data="cashTrees"
              checkStrictly
              :default-expanded-keys="expandedKey"
              @check="checkCashTree"
              v-model="selectedPropertyKeys"
              :replaceFields="{
                key: 'id',
                title: 'targetName',
                children: 'children',
              }"
            ></a-tree>
          </div>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <div class="target_tree">
            <a-tree
              checkable
              :selectable="false"
              :tree-data="nonFinancialTrees"
              checkStrictly
              :default-expanded-keys="expandedKey"
              @check="checknonFinancialTree"
              v-model="selectedPropertyKeys"
              :replaceFields="{
                key: 'id',
                title: 'targetName',
                children: 'children',
              }"
            ></a-tree>
          </div>
        </a-col>
      </a-row>
    </a-modal>

    <!-- 设置分值区间 -->
    <a-modal
      v-model="settingTarget"
      destroyOnClose
      @ok="handleSubmitSetting"
      title="设置指标分值区间"
      :maskClosable="false"
      :afterClose="handleSettingClose"
      :width="1000"
    >
      <!-- <a-card> -->
      <a-row :gutter="20" style="margin-top: 15px; margin-bottom: 25px">
        <a-col :span="4">
          <div
            style="transform: rotateZ(342deg); padding: 5px 0px"
            :class="
              settingForm.targetType == '0'
                ? 'target_type_style'
                : 'target_type_style_fei'
            "
          >
            <span v-if="settingForm.targetType == '0'">非财务指标</span>
            <span v-else>财务指标</span>
          </div>
        </a-col>
        <a-col :span="20" style="font-weight: 600">
          指标名称：{{ settingForm.targetName }}
        </a-col>
      </a-row>
      <!-- </a-card> -->
      <a-card style="margin-top: 10px">
        <a-row :gutter="20" v-if="settingForm.dataType == '1'">
          <a-col>
            <div class="estimate-list">
              <div class="estimate-question">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="8" style="background: #f3f3f3">
                    <span style="margin-left: -30px">最小值</span>
                  </a-col>
                  <a-col :span="8" style="background: #f3f3f3">
                    <span style="margin-left: -30px">最大值</span>
                  </a-col>
                  <a-col :span="8" style="background: #f3f3f3">
                    <span style="margin-left: -30px">
                      分&nbsp;&nbsp;&nbsp;&nbsp;值
                    </span>
                  </a-col>
                </a-row>
              </div>
              <div style="width: 140px; text-align: center; margin-left: -10px">
                <div style="width: 100%; background: #f3f3f3">操作</div>
              </div>
            </div>
            <div
              class="estimate-list"
              v-for="(scoreResult, index) in scoreResultList"
              :key="index"
            >
              <div style="margin-right: 10px">{{ index + 1 }}</div>
              <div class="estimate-question">
                <a-row :gutter="10">
                  <a-col :span="7">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <!-- <template #title>
                          分值区间的开始值必须比结束值低，且只能输入数字
                          <br />
                          例如：10 至 60 ，分值：10
                        </template> -->
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.minScore"
                          :min="0"
                          :max="9999999999"
                          :step="1"
                          maxlength="20"
                          style="width: 200px; height: 30px"
                          :disabled="index == 0 ? true : false"
                          :style="index == 0 ? 'background: #f3f3f3;' : ''"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>

                  <div v-if="index == 0">
                    <a-col :span="2">
                      <a-form-item>
                        <a-tooltip placement="topLeft">
                          <span>值&nbsp;&lt;</span>
                        </a-tooltip>
                      </a-form-item>
                    </a-col>
                  </div>
                  <div v-if="index != scoreResultList.length - 1 && index != 0">
                    <a-col :span="2">
                      <a-form-item>
                        <a-tooltip placement="topLeft">
                          <span>&lt;=&nbsp;值&nbsp;&lt;</span>
                        </a-tooltip>
                      </a-form-item>
                    </a-col>
                  </div>
                  <div v-if="index == scoreResultList.length - 1">
                    <a-col :span="2">
                      <a-form-item>
                        <a-tooltip placement="topLeft">
                          <span>&lt;=&nbsp;值</span>
                        </a-tooltip>
                      </a-form-item>
                    </a-col>
                  </div>

                  <a-col :span="7" label-width="0px">
                    <a-form-item>
                      <a-tooltip placement="topLeft">
                        <!-- <template #title>
                          分值区间的结束值必须比开始值高，且只能输入数字
                          <br />
                          例如：60 至 100 ，分值：5
                        </template> -->
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.maxScore"
                          :min="0"
                          :max="9999999999"
                          :step="1"
                          maxlength="20"
                          style="width: 200px; height: 30px"
                          :disabled="
                            index == scoreResultList.length - 1 ? true : false
                          "
                          :style="
                            index == scoreResultList.length - 1
                              ? 'background: #f3f3f3;'
                              : ''
                          "
                          @change="copyMax(scoreResult, index)"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <!-- <template #title>分值最高为：10，最低为-10</template> -->
                        <a-input-number
                          controls-position="right"
                          v-model="scoreResult.targetScore"
                          :min="-10"
                          :max="10"
                          :step="1"
                          maxlength="20"
                          style="width: 200px; height: 30px"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="estimate-button">
                <a-tooltip placement="topLeft">
                  <template #title>新增分值区间</template>
                  <img
                    src="./images/add.png"
                    style="width: 20px; height: 20px"
                    @click="addScoreResult"
                    v-if="index != scoreResultList.length - 1"
                  />
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template #title>删除分值区间</template>
                  <img
                    src="./images/delete.png"
                    style="width: 20px; height: 20px; margin-top: -3px"
                    @click="removeScoreResult(scoreResult)"
                    v-if="index != scoreResultList.length - 1 && index != 0"
                  />
                </a-tooltip>
              </div>
            </div>
          </a-col>
          <a-row style="color: red; margin-top: 10px; margin-left: 28px">
            <a-col>
              注：1、分值区间的开始最小值必须等于上一个结束的最大值，例如：10 至
              60 ，60 至 90，90 至 100
            </a-col>
            <a-col style="padding-left: 28px">
              2、每条分值区间包小不包大，及 最小值 &lt;= 值 &lt; 最大值
            </a-col>
            <a-col style="padding-left: 28px">
              3、分值区间第一条不能填写最小值
            </a-col>
            <a-col style="padding-left: 28px">
              4、分值区间最后一条不能填写最大值
            </a-col>
          </a-row>
        </a-row>
        <a-row v-else>
          <a-col class="target_select">
            <div style="width: 50%; background: #f3f3f3; padding-left: 10px">
              指标选项
            </div>
            <div style="width: 50%; background: #f3f3f3; padding-left: 10px">
              分值
            </div>
          </a-col>
          <a-col
            v-for="(scoreResult, index) in scoreResultList"
            :key="index"
            class="target_select"
          >
            <div style="width: 50%">
              {{ index + 1 }}、{{ scoreResult.targetName }}
            </div>
            <div style="width: 50%">
              <a-input-number
                controls-position="right"
                v-model="scoreResult.targetScore"
                :min="-10"
                :max="10"
                :step="1"
                maxlength="20"
                style="width: 200px; height: 30px"
              />
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import './style.less'
import mixin from './mixin'
import {
  remove,
  getTableData,
  freeze,
  thaw,
  getTargetTreeList,
  getChooseList,
  add,
  detail,
  update,
  getUsedData,
} from './api'

const usedColumns = [
  {
    dataIndex: 'companyName',
    title: '公司名称',
  },
  {
    dataIndex: 'companyCode',
    width: 100,
    title: '公司代码',
    scopedSlots: { customRender: 'companyName' },
  },
  {
    title: '内部评级',
    dataIndex: 'creditLevel',
    width: 90,
  },
  {
    title: '财报时间',
    dataIndex: 'reportTime',
    width: 90,
  },
  {
    title: '内部评分',
    dataIndex: 'totalScore',
    width: 90,
  },
  {
    title: '操作人',
    dataIndex: 'operator',
    width: 100,
  },
  {
    title: '操作时间',
    dataIndex: 'createTime',
    width: 120,
    key: 'createTime',
  },
]

export default {
  mixins: [mixin],
  data() {
    return {
      targetData: [],
      rowKey: 'id',
      loading: false,
      bordered: true,
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      chooseTarget: false,
      modalTitle: '新增',
      chooseData: [],
      formCard: this.$form.createForm(this),
      financeTargetNum: 0,
      noFinancetargetNum: 0,
      weightAll: 100,
      targetList: [],
      // div拖动参数
      ending: null,
      dragging: null,
      // 指标树数据集
      propertyTree: [],
      // 选择资产负债指标
      selectPropertyNodeList: [],
      // 选择损益指标
      selectLossNodeList: [],
      // 选择现金流量指标
      selectCashNodeList: [],
      // 选择非财务指标
      selectNonFinancialNodeList: [],
      // 设置分值弹窗
      settingTarget: false,
      settingForm: {},
      scoreResultList: [],
      settingIndex: 0,
      targetItemList: [],
      checkDetail: false,
      id: '',
      usedColumns,
      usedData: [],
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    // 评分卡列表
    this._getTableData()
    // 指标列表
    this._getChooseTargetList()
  },
  methods: {
    // 获取被引用次数数据列表
    async dataOpen({ id }) {
      try {
        const { data } = await getUsedData(id)
        this.usedData = data
      } catch (error) {
        console.log(error)
      }
    },
    //上一行最大值=下一行最小值
    copyMax(scoreResult, index) {
      let i = 0
      const nextIndex = index + 1
      for (; i < this.scoreResultList.length; i++) {
        if (i === nextIndex) {
          this.scoreResultList[i].minScore = scoreResult.maxScore
        }
      }
    },

    // 获取列表数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },

    // 获取选择指标列表
    _getChooseTargetList() {
      getTargetTreeList().then(({ data }) => {
        this.propertyTree = data
      })
    },
    // 新增评分卡
    addCard() {
      this.id = ''
      this.selectPropertyNodeList = []
      this.selectLossNodeList = []
      this.selectCashNodeList = []
      this.selectNonFinancialNodeList = []
      this.checkDetail = false
      this.financeTargetNum = 0
      this.noFinancetargetNum = 0
      this.weightAll = 100
      this.targetList = []
      this.visible = true
      this.modalTitle = '新增自定义评分卡'
    },
    // 点击编辑
    handleEdit({ id }) {
      detail(id).then(({ data }) => {
        this.id = id
        var cardName = data.cardName
        setTimeout(() => {
          this.formCard.setFieldsValue({
            cardName,
          })
        }, 20)
        // 计算财务、非财务统计数量
        var finNum = 0
        var noFinNum = 0
        data.customTargetList.forEach(item => {
          if (item.targetType == '0') {
            noFinNum = noFinNum + 1
          } else {
            finNum = finNum + 1
          }
        })
        this.financeTargetNum = finNum
        this.noFinancetargetNum = noFinNum
        this.weightAll = 0
        this.targetList = data.customTargetList
        console.log('data', data)
        console.log('data.customTargetList', data.customTargetList)
        console.log('this.targetList', data.customTargetList)
        this.checkDetail = false
        this.visible = true
        this.modalTitle = '修改自定义评分卡'
      })
    },
    handleDetail({ id }) {
      detail(id).then(({ data }) => {
        var cardName = data.cardName
        setTimeout(() => {
          this.formCard.setFieldsValue({
            cardName,
          })
        }, 20)
        // 计算财务、非财务统计数量
        var finNum = 0
        var noFinNum = 0
        data.customTargetList.forEach(item => {
          if (item.targetType == '0') {
            noFinNum = noFinNum + 1
          } else {
            finNum = finNum + 1
          }
        })
        this.financeTargetNum = finNum
        this.noFinancetargetNum = noFinNum
        this.weightAll = 0
        this.targetList = data.customTargetList
        this.checkDetail = true
        this.visible = true
        this.modalTitle = '自定义评分卡详情'
      })
    },
    // 提交和编辑
    handleSubmit() {
      this.formCard.validateFields(async (err, values) => {
        if (!err) {
          if (this.targetList.length == 0) {
            this.$notification.error({
              message: '提示',
              description: '没有维护指标，不能点击确定',
            })
            return false
          }
          if (Number(this.weightAll) > 0) {
            this.$notification.error({
              message: '提示',
              description: '权重未分配完',
            })
            return false
          }
          if (Number(this.weightAll) < 0) {
            this.$notification.error({
              message: '提示',
              description: '未分配权重不能小于0',
            })
            return false
          }
          // 校验指标分值区间是否设置
          for (var i = 0; i < this.targetList.length; i++) {
            if (
              this.targetList[i].targetWeight == null ||
              this.targetList[i].targetWeight == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '请补充第' + (i + 1) + '个指标的权重，没有权重可填写0',
              })
              return false
            }
            if (this.targetList[i].customTargetRangeList.length == 0) {
              this.$notification.warning({
                message: '提示',
                description: '请设置第' + (i + 1) + '个指标的分值区间',
              })
              return false
            }
            // 处理指标id
            if (
              this.targetList[i].targetChooseId &&
              this.targetList[i].targetChooseId != '' &&
              this.targetList[i].targetChooseId != undefined
            ) {
              this.targetList[i].id = this.targetList[i].targetChooseId
            }
          }

          // if (!this.id) {
          //   this.id = "";
          // }
          try {
            if (!this.id) {
              const { message } = await add({
                ...values,
                customTargetList: this.targetList,
                id: this.id,
              })
              this.$notification.success({
                message: '提示',
                description: message,
              })
            } else {
              const { message } = await update({
                ...values,
                customTargetList: this.targetList,
                id: this.id,
              })
              this.$notification.success({
                message: '提示',
                description: message,
              })
            }
            this.visible = false
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    //冻结
    handleFreeze({ id }) {
      freeze(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    //解冻
    handleThaw({ id }) {
      thaw(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    // 打开设置分值区间弹窗
    goToSetting(target, index) {
      this.scoreResultList = []
      console.log('指标：' + JSON.stringify(target))
      console.log('第几行：' + index)
      this.settingForm.targetName = target.targetName
      this.settingForm.targetType = target.targetType
      this.settingForm.dataType = target.dataType
      this.settingForm.chooseItemId = target.chooseItemId
      this.settingIndex = index
      if (target.customTargetRangeList.length > 0) {
        target.customTargetRangeList.forEach(item => {
          item.key = Date.now()
        })
        this.scoreResultList = target.customTargetRangeList
      } else {
        if (target.dataType == '1') {
          this.scoreResultList.push(
            {
              minScore: null,
              maxScore: null,
              targetScore: null,
              key: Date.now(),
              targetId: '',
              targetName: '',
              chooseItemId: null,
            },
            {
              minScore: null,
              maxScore: null,
              targetScore: null,
              key: Date.now(),
              targetId: '',
              targetName: '',
              chooseItemId: null,
            },
            {
              minScore: null,
              maxScore: null,
              targetScore: null,
              key: Date.now(),
              targetId: '',
              targetName: '',
              chooseItemId: null,
            },
          )
        } else {
          // 获取指标项包含的选项
          getChooseList({ id: target.id }).then(({ data }) => {
            this.targetItemList = data
            this.targetItemList.push({
              value: 0,
              lable: '未选择',
            })
            this.targetItemList.forEach(item => {
              this.scoreResultList.push({
                minScore: null,
                maxScore: null,
                targetScore: null,
                targetId: item.value,
                targetName: item.lable,
                chooseItemId: item.id,
                key: Date.now(),
              })
            })
          })
        }
      }
      this.settingTarget = true
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .ant-card-body {
  padding: 10px;
  zoom: 1;
}

/deep/ .ant-form-item {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  margin-bottom: 0px;
  vertical-align: top;
  display: flex;
}

/deep/ .ant-modal-body {
  padding: 10px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

/deep/ .ant-input-number {
  box-sizing: border-box;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  width: 100%;
  height: 27px;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  transition: all 0.3s;
  display: inline-block;
  width: 90px;
  margin: 0;
  padding: 0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

/deep/ .ant-input-number-input {
  width: 100%;
  height: 25px;
  padding: 0 11px;
  text-align: left;
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  outline: 0;
  transition: all 0.3s linear;
  -moz-appearance: textfield !important;
}

/**滚动条的宽度*/
::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

// 滚动条的滑块
::v-deep ::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 3px;
}

// 指标树将不能选择的复选框隐藏
/deep/ .ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
  background-color: #f5f5f5;
  border-color: #d9d9d9 !important;
  display: none;
}

/deep/ li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher),
/deep/ li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper,
/deep/ li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
  color: rgba(0, 0, 0, 0.65);
  cursor: not-allowed;
}
</style>
